{
  "appName": "Al-Musafer Fuel",
  "brand": "المسافر",
  "platform": "المنصة",
  "actions": {
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "edit": "تعديل",
    "create": "إضافة",
    "search": "بحث",
    "retry": "تحديث",
    "close": "إغلاق",
    "confirm": "تأكيد",
    "apply": "تطبيق",
    "reset": "إعادة تعيين",
    "rotate": "تدوير",
    "view": "عرض",
    "expandAll": "توسيع الكل",
    "collapseAll": "طي الكل",
    "addItem": "إضافة عنصر"
  },
  "yes": "نعم",
  "no": "لا",
  "nav": {
    "dashboard": "لوحة التحكم",
    "users": "المستخدمون",
    "settings": "الإعدادات",
    "logout": "تسجيل الخروج"
  },
  "language": {
    "label": "اللغة",
    "ar": "العربية",
    "en": "English",
    "switchTo": {
      "ar": "التبديل إلى العربية",
      "en": "التبديل إلى الإنجليزية"
    }
  },
  "theme": {
    "switchToLight": "التبديل إلى الوضع الفاتح",
    "switchToDark": "التبديل إلى الوضع الداكن"
  },
  "preferences": {
    "label": "إعدادات اللغة والمظهر"
  },
  "state": {
    "loading": "جاري التحميل...",
    "empty": "لا توجد بيانات",
    "error": "تعذر تحميل البيانات"
  },
  "pagination": {
    "page": "صفحة {{page}} من {{totalPages}}",
    "total": "{{total}} سجل",
    "next": "التالي",
    "previous": "السابق",
    "label": "التنقل بين الصفحات",
    "morePages": "صفحات أخرى"
  },
  "search": {
    "noResults": "لا نتائج مطابقة للبحث",
    "placeholder": "بحث..."
  },
  "identity": {
    "nameNotProvided": "لا يوجد اسم"
  },
  "selectItem": {
    "placeholder": "اختر عنصرا...",
    "selected": "عنصر محدد"
  },
  "multiselect": {
    "selectSomeItems": "اختر عناصر"
  },
  "media": {
    "imageViewer": "عارض الصور",
    "viewLarger": "عرض بحجم أكبر",
    "editImage": "تعديل الصورة",
    "cropAndAdjust": "قص الصورة وضبطها",
    "zoom": "التكبير",
    "zoomIn": "تكبير",
    "zoomOut": "تصغير",
    "rotation": "التدوير",
    "cameraCapture": "التقاط بالكاميرا",
    "positionInFrame": "ضع نفسك داخل الإطار",
    "takePhoto": "التقاط صورة",
    "uploadFile": "رفع ملف",
    "uploaded": "تم الرفع",
    "dragDropImage": "اسحب صورة وأفلتها هنا",
    "selectedLabel": "المحدد",
    "deleteTitle": "حذف {{name}}؟",
    "deleteMessage": "ستتم إزالة {{name}}. لا يمكن التراجع عن هذا الإجراء."
  },
  "treeDemo": {
    "title": "مستعرض الملفات",
    "searchPlaceholder": "البحث في الملفات",
    "reports": "التقارير",
    "salesReport": "تقرير المبيعات",
    "inventoryReport": "تقرير المخزون",
    "documents": "المستندات",
    "invoiceTemplate": "نموذج فاتورة",
    "configurations": "الإعدادات"
  },
  "table": {
    "resetFilters": "إعادة تعيين الفلاتر",
    "clearFilter": "إزالة الفلتر: {{label}}",
    "sortBy": "الفرز حسب {{column}}",
    "sortedAscending": "ترتيب تصاعدي",
    "sortedDescending": "ترتيب تنازلي",
    "selectRow": "تحديد الصف",
    "selectAllRows": "تحديد كل الصفوف",
    "selectPage": "تحديد كل عناصر هذه الصفحة",
    "selectAllMatching": "تحديد كل {{count}} عنصر مطابق",
    "selectedCount": "تم تحديد {{count}}",
    "clearSelection": "إلغاء التحديد",
    "permissionDeniedTitle": "لا يمكنك عرض هذه البيانات",
    "permissionDeniedDescription": "ليس لديك صلاحية لعرض هذه البيانات.",
    "initialEmptyTitle": "لا توجد سجلات بعد",
    "filteredEmptyDescription": "جرب بحثا مختلفا أو عدل الفلاتر.",
    "errorDescription": "أعد المحاولة أو تواصل مع المسؤول إذا استمرت المشكلة.",
    "partialTitle": "تعذر تحميل بعض البيانات",
    "loading": "جاري تحميل السجلات",
    "pageSizeLabel": "عدد الصفوف بالصفحة",
    "moreActions": "المزيد من الإجراءات",
    "actions": "الإجراءات",
    "rowActionsLabel": "إجراءات {{name}}"
  },
  "combobox": {
    "clearSelection": "مسح التحديد",
    "search": "بحث...",
    "options": "الخيارات",
    "placeholder": "اختر...",
    "empty": "لا توجد نتائج",
    "clearOption": "بدون",
    "removeSelection": "إزالة {{label}}",
    "selectedCount_one": "تم اختيار {{count}} عنصر",
    "selectedCount_two": "تم اختيار {{count}} عنصر",
    "selectedCount_few": "تم اختيار {{count}} عناصر",
    "selectedCount_many": "تم اختيار {{count}} عنصر",
    "selectedCount_other": "تم اختيار {{count}} عنصر"
  },
  "password": {
    "show": "إظهار كلمة المرور",
    "hide": "إخفاء كلمة المرور"
  },
  "phone": {
    "countryCode": "رمز الدولة"
  },
  "breadcrumb": {
    "label": "مسار التنقل",
    "more": "المزيد"
  },
  "toaster": {
    "label": "الإشعارات"
  }
}
